//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var BASE_URL = "/prototype/global-reporting";
import { createExport } from "@/mixins/createExport";

export default {
  mixins: [createExport],
  data: function data() {
    return {
      periodStart: moment().format("MM/DD/YYYY"),
      headers: ['Move In Date', 'Move Out Date', 'Resident Name', 'Phone Number', 'Address', 'Address 2', 'City, State ZIP', 'Property', 'Plan Type', 'Effective Date', 'End Date', 'Price'],
      fields: ['move_in_date', 'move_out_date', 'res_name', 'phone', 'add_line_1', 'add_line_2', 'city', 'prop', 'plan_type', 'eff_date', 'end_date', 'price'],
      items: [],
      loading: false
    };
  },
  created: function created() {
    var _this = this;

    Event.$on("global-insurance-report", function () {
      _this.$children[0].showModal = true;
      _this.load();
    });
    Event.$on("exportGlobalInsuranceToExcel", function () {
      return _this.exportToExcel();
    });
  },
  beforeDestroy: function beforeDestroy() {
    Event.$off("global-insurance-report");
    Event.$off("exportGlobalInsuranceToExcel");
  },

  methods: {
    load: function load() {
      var _this2 = this;

      this.items = [];
      this.loading = true;
      axios.post(BASE_URL + "/global-insurance-report", {
        periodStart: moment(this.periodStart).startOf("month")
      }).then(function (response) {
        _this2.items = response.data;
        _this2.loading = false;
      });
    },
    applyFilter: function applyFilter() {
      this.load();
    },
    exportToExcel: function exportToExcel() {
      this.loading = true;

      var data = {
        exportExcel: true,
        periodStart: this.periodStart
      };

      this.createExport(data, BASE_URL + "/global-insurance-report", "global-insurance-report", ".xlsx");

      this.loading = false;
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/reporting/GlobalInsuranceReport.vue
// module id = OVcF
// module chunks = 0 1